export const ID_ATTRIBUTE = "data-comment-id";
export const RESOLVED_ATTRIBUTE = "data-comment-resolved";
export const PARENT_ATTRIBUTE = "data-comment-parent";
export const TYPE_ATTRIBUTE = "data-comment-type";
export const MARKER_NAME = "comment";
export const VIEW_NAME = "comment";
export const MODEL_NAME = "comment";
export const GROUP_NAME = "comment";
